import { styled } from '@linaria/react';
import { memo } from 'react';
import { SearchResultEntry, SearchResultEntryWithType } from '../../../../types/state';
import { useElementSize } from '../../Hooks/useElementSize';
import APP_BREAKPOINTS from '../../styles/breakpoints';
import SearchRecommendationsGrid from './SearchRecommendationsGrid';
import "./index.linaria.module.css!=!./index?./index.linaria.module.css?css=H4sIAAAAAAAAA9MrNitJyTJPr85IzUzPKLEyNDBQtS7PTCnJgDBruQAybLwdIgAAAA=="
const StyledDiv = /*#__PURE__*/styled('div')({
  name: "StyledDiv",
  class: "s6tdj7g",
  propsAsIs: false
});
interface ISearchRecommendations {
  onOpenMenu(slug: string, options?: any): void;
  onOpenRoom(slug: string): void;
  onTagClick(tag: string): void;
  onScroll?(offset: number): void;
  models: Array<SearchResultEntry | SearchResultEntryWithType>;
  searchString: string;
  altDisplay?: boolean;
  source: string;
}
interface IGrid extends ISearchRecommendations {
  columnWidth: number;
  height: number;
  width: number;
}
const Grid = memo((props: IGrid) => {
  const {
    columnWidth,
    width,
    searchString
  } = props;
  const smallViewport = width < APP_BREAKPOINTS.tablet;
  const columnCount = smallViewport ? 1 : Math.ceil(width / columnWidth);
  const cellWidth = width / columnCount;
  const gridProps = {
    ...props,
    cellWidth,
    columnCount,
    columnWidth: cellWidth,
    minRowHeight: 90,
    searchString
  };
  return <SearchRecommendationsGrid {...gridProps} />;
});
const SearchRecommendations = memo((props: ISearchRecommendations) => {
  const gridProps = {
    ...props,
    columnWidth: 600
  };
  const {
    ref,
    height,
    width
  } = useElementSize();
  return <StyledDiv ref={ref} data-testid="SearchRecommendations__List">
            {height && <Grid height={height} width={width} {...gridProps} />}
        </StyledDiv>;
});
export default SearchRecommendations;